"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceofEntity = void 0;
/**
 *  Checks whether the given object is an instance of the Entity interface.
 */
function instanceofEntity(object) {
    return 'guid' in object;
}
exports.instanceofEntity = instanceofEntity;
//# sourceMappingURL=entity.js.map